import { Empty } from "components/Empty";
import FilterButtonGroup from "components/FilterButtonGroup";
import { useField } from "lib/form";
import { mq, device } from "lib/media-query";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

export const AangebodenSindsFilter = ({ condensed }) => {
    const filterOptions = useFilter("aanbodsindsdagen");
    const [aangebodenSindsValue, , onAangebodenSindsChange] = useField("aanbodSinds");

    const aangebodenSindsOptions =
        filterOptions.map((option) => ({
            id: option,
            displayName: `${option} ${option === 1 ? "dag" : "dagen"}`,
            naam: `${option}`
        })) || [];

    return (
        <Grid condensed={condensed}>
            <FilterButtonGroup
                filterId="filter-aanbodsinds"
                options={aangebodenSindsOptions}
                value={aangebodenSindsValue || []}
                handleChange={(_, value) => onAangebodenSindsChange(value)}
                datalayerKey="aanbodSinds"
                columns={condensed ? 2 : aangebodenSindsOptions.length}
            />
            <Empty />
        </Grid>
    );
};
